import apiClient from './axios';

export interface UserDto {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    role: string;
    createdAt: string;
}

export interface UserDetailDto extends UserDto {}

export interface UpdateUserRequest {
    id: string;
    firstName: string;
    lastName: string;
    role: string;
}

export interface ChangePasswordRequest {
    id: string;
    newPassword: string;
}

export interface CreateUserRequest {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    role: string;
}

export const getUsers = async (params: { page?: number; pageSize?: number; search?: string }) => {
    const response = await apiClient.get('/admin/users', { params });
    return response.data;
};

export const getUserDetail = async (id: string) => {
    const response = await apiClient.get(`/admin/users/${id}`);
    return response.data;
};

export const createUser = async (data: CreateUserRequest) => {
    const response = await apiClient.post('/admin/users', data);
    return response.data;
};

export const updateUser = async (data: UpdateUserRequest) => {
    const response = await apiClient.put('/admin/users', data);
    return response.data;
};

export const changePassword = async (data: ChangePasswordRequest) => {
    const response = await apiClient.post('/admin/users/change-password', data);
    return response.data;
};
